import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Instagram, Palette } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

const links = [
  { to: "/", label: "Home" },
  { to: "/gallery", label: "Examples" },
  { to: "/process", label: "How It's Made" },
  { to: "/events", label: "Events" },
  { to: "/testimonials", label: "Reviews" },
  { to: "/order", label: "Order Now" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const { settings } = useSettings();

  return (
    <header className="sticky top-0 z-50 bg-cream/90 backdrop-blur-md border-b-[3px] border-ink" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-5 py-3 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group" data-testid="nav-logo">
          <span className="grid place-items-center w-10 h-10 rounded-xl bg-bubble border-[3px] border-ink shadow-brut group-hover:rotate-6 transition-transform">
            <Palette className="w-5 h-5 text-white" strokeWidth={2.5} />
          </span>
          <span className="font-display font-bold text-xl leading-none">{settings?.shop_name || "Caricatures"}</span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {links.map((l) => (
            <Link key={l.to} to={l.to} data-testid={`nav-${l.label.toLowerCase().replace(" ", "-")}`}
              className={`font-display font-medium px-4 py-2 rounded-full border-[3px] transition-[transform,background-color] hover:-translate-y-0.5 ${
                pathname === l.to ? "bg-sun border-ink shadow-brut" : "border-transparent hover:border-ink"
              }`}>
              {l.label}
            </Link>
          ))}
          {settings?.instagram_url && (
            <a href={settings.instagram_url} target="_blank" rel="noreferrer" data-testid="nav-instagram"
              className="ml-2 grid place-items-center w-10 h-10 rounded-full border-[3px] border-ink bg-white shadow-brut hover:-translate-y-0.5 transition-transform">
              <Instagram className="w-5 h-5" />
            </a>
          )}
        </nav>

        <button className="md:hidden brut-btn !px-3 !py-2 bg-sun" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t-[3px] border-ink bg-cream px-5 py-4 flex flex-col gap-2">
          {links.map((l) => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)}
              className="font-display font-medium px-4 py-3 rounded-xl border-[3px] border-ink bg-white shadow-brut">
              {l.label}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
}
